import { LOGIN, LOGOUT } from "../types";

const loginUser = (user) => {
    // await setTimeout(() => {
    //     console.log('after 2 seconds.');
    // }, 2000);
    return {
        type: LOGIN, user
    }
}

const removeUser = () => {
    return {
        type: LOGOUT
    }
}

export {
    loginUser,
    removeUser
}